/**
 * MuiDialog
 */
const MuiDialog = {
  styleOverrides: {
    paper: {
      borderRadius: 16
    },
    paperFullScreen: {
      borderRadius: 0
    }
  }
};
export const MuiDialogTitle = {
  defaultProps: {
    variant: 'h3'
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      padding: theme.spacing(5)
    })
  }
};
export const MuiDialogContent = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      padding: theme.spacing(2, 5, 5)
    })
  }
};
export const MuiDialogActions = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      padding: theme.spacing(2, 5, 5),
      '& > :not(:first-of-type)': {
        marginLeft: theme.spacing(2)
      }
    })
  }
};
export default MuiDialog;